import { TranslationKeys } from '~frontend-common/i18n/english/car-details-subquestion.i18n';

const keys: TranslationKeys = {
  carDetails: {
    choices: {
      commuteDetails: {
        pleasure: 'Plaisir',
        school: 'Aller à l’école',
        work: 'Aller au travail',
      },
      conditionAtPurchase: {
        demo: 'Démo',
        new: 'Neuve',
        used: 'Usagé',
      },
      paymentStatus: {
        financed: 'Financée',
        leased: 'Louée',
        paid: 'Payée',
      },
    },
    fields: {
      carDescription: {
        modelYear: 'Année',
        make: 'Marque',
        model: 'Modèle',
      },
      commuteDetails: 'Usage principal de la voiture',
      conditionAtPurchase: 'État de la voiture lors de l’achat',
      dailyKilometers: 'Nombre de kilomètres, en moyenne, parcourus quotidiennement avec la voiture',
      kmOnOdometer: "Kilométrage sur l’odomètre au moment de l'achat",
      paymentStatus: 'Statut du paiement de la voiture',
      possessionDate: "Date d'acquisition de la voiture",
      security: 'Systèmes de sécurité installés sur la voiture',
      winterTires: "Avez-vous des pneus d'hiver pour votre véhicule ?",
      yearlyKilometers: 'Nombre de kilomètres, en moyenne, parcourus annuellement avec la voiture',
      yearlyDaysOutsideOfProvince:
        'Nombre de semaines, en moyenne, parcourus annuellement hors de votre province de résidence',
    },
    helpers: {
      possessionDate: 'C’est la date à laquelle l’immatriculation du véhicule a été transférée à votre nom.',
      dailyKilometers: 'Un canadien conduit en moyenne 20km par jour',
      security: 'Des informations inexactes peuvent affecter une future réclamation',
      winterTires: 'Économisez jusqu’à 100$ avec des pneus d’hiver.',
      yearlyKilometers: 'Un canadien conduit en moyenne 15-20 000 km par année',
    },
    kilometers: 'Km',
    noOptionMessage: {
      carDescription: {
        selectModelYear: 'Sélectionnez l’année en premier',
        selectMake: 'Sélectionnez la marque en premier',
      },
    },
    placeholders: {
      carDescription: {
        modelYear: 'ex. 2019',
        make: 'ex. Hyundai',
        model: 'ex. Accent Essential 4DR',
      },
      dailyKilometers: 'ex. 15',
      kmOnOdometer: 'ex. 5',
      yearlyKilometers: 'ex. 20',
      yearlyDaysOutsideOfProvince: 'ex. Jamais',
    },
    title: 'Ajoutez toutes vos voitures ici.',
    subtitle: "Vous devez être le propriétaire immatriculé d'au moins une voiture.",
    actions: {
      add: 'Ajouter une voiture',
      remove: 'Supprimer',
      edit: 'Modifier',
    },
  },
};

export default keys;
